<template>
<div class="marathon centered-box locations-white locations-generic">
    <div class="locations-title">Des Plaines River Marathon 2023</div>
    <br/>
    Race day for <strong>the 66th.</strong> marathon is Sunday, <strong>May 21.</strong> The course runs 18.5 miles on the Des Plaines River south from Libertyville, Illinois. A shorter event—the 5.25-mile 'Minithon'—runs from Potawatomi Woods in Wheeling, Illinois. 
    <br/><br/>
    You can rent kayaks or canoes from us after Saturday, April 1 but be aware that you'll first need to register with the event organizers. For more information, visit their Website <strong>at:</strong> <a href="www.CanoeMarathon.com">www.CanoeMarathon.com</a>
    <br/><br/>
<h5>Pricing:</h5> Full marathon: Single kayak—$80; Tandem kayak—$120; Canoe—$100
Mini marathon: Single kayak—$60; Tandem kayak—$100; Canoe—$80<br><br>
Rental includes paddles and life jackets. 
<br><br>
</div>
</template>

<script>
export default { 
  name: "Marathon",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.marathon {
  color: black;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
